import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import Header from '../components/Header';

export default function ContactUs() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const locale = sessionStorage.getItem('versant_locale') || 'en';

  const translations = {
    en: {
      title: "Get in Touch",
      subtitle: "Have a question or feedback? Fill out the form below or email us at ",
      successTitle: "Thank you!",
      successText: "Your message has been sent successfully. We'll get back to you soon.",
      namePlace: "Your Name",
      emailPlace: "Email address",
      msgPlace: "Your Message",
      btn: "Send Message"
    },
    es: {
      title: "Ponte en Contacto",
      subtitle: "¿Tienes alguna pregunta o comentario? Completa el formulario a continuación o envíanos un correo a ",
      successTitle: "¡Gracias!",
      successText: "Tu mensaje ha sido enviado con éxito. Nos pondremos en contacto contigo pronto.",
      namePlace: "Tu Nombre",
      emailPlace: "Correo Electrónico",
      msgPlace: "Tu Mensaje",
      btn: "Enviar Mensaje"
    },
    pt: {
      title: "Entre em Contato",
      subtitle: "Tem alguma dúvida ou feedback? Preencha o formulário abaixo ou envie um e-mail para ",
      successTitle: "Obrigado!",
      successText: "Sua mensagem foi enviada com sucesso. Entraremos em contato em breve.",
      namePlace: "Seu Nome",
      emailPlace: "Endereço de E-mail",
      msgPlace: "Sua Mensagem",
      btn: "Enviar Mensagem"
    },
    ja: {
      title: "お問い合わせ",
      subtitle: "ご質問やフィードバックがありますか？以下のフォームに入力するか、こちらまでメールでお問い合わせください：",
      successTitle: "送信完了",
      successText: "メッセージは正常に送信されました。追ってご連絡いたします。",
      namePlace: "お名前",
      emailPlace: "メールアドレス",
      msgPlace: "お問い合わせ内容",
      btn: "メッセージを送信"
    }
  };

  const t = translations[locale] || translations.en;

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ name, email, message });
    setSubmitted(true);
  };

  return (
    <>
      <Helmet>
        <title>{t.title} | Versant Practice Test</title>
        <meta name="description" content="Have questions? Contact the Versant Practice Test team. We are here to help you with your test preparation needs." />
      </Helmet>
      <Header />
      <div className="bg-gray-50">
        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-lg shadow-md">
            <div>
              <h1 className="text-center text-3xl font-extrabold text-gray-900">
                {t.title}
              </h1>
              <p className="mt-2 text-center text-sm text-gray-600">
                {t.subtitle} <a href="mailto:hello@versantpro.com" className="font-medium text-green-600 hover:text-green-500">hello@versantpro.com</a>.
              </p>
            </div>
            {submitted ? (
              <div className="text-center p-4 bg-green-100 text-green-800 rounded-md">
                <h3 className="text-lg font-medium">{t.successTitle}</h3>
                <p className="mt-1">{t.successText}</p>
              </div>
            ) : (
              <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                <div className="rounded-md shadow-sm -space-y-px">
                  <div>
                    <label htmlFor="name" className="sr-only">{t.namePlace}</label>
                    <input id="name" name="name" type="text" required value={name} onChange={(e) => setName(e.target.value)} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm" placeholder={t.namePlace} />
                  </div>
                  <div>
                    <label htmlFor="email-address" className="sr-only">{t.emailPlace}</label>
                    <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm" placeholder={t.emailPlace} />
                  </div>
                  <div>
                    <label htmlFor="message" className="sr-only">{t.msgPlace}</label>
                    <textarea id="message" name="message" rows="4" required value={message} onChange={(e) => setMessage(e.target.value)} className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-green-500 focus:border-green-500 focus:z-10 sm:text-sm" placeholder={t.msgPlace}></textarea>
                  </div>
                </div>

                <div>
                  <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                    {t.btn}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}